import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

const UpcomingSessions = observer(class UpcomingSessions extends React.Component {
  componentWillUnmount() {
    this.props.store.ScheduleStore.events = [];
  }

  renderResults() {
    const { translation } = this.props;
    const { ScheduleStore } = this.props.store;
    const { events } = ScheduleStore;

    if(events.length > 0) {
      return (
        <table>
          <thead>
            <tr>
              <th id="heading-date" className="subtitle" scope="col">{translation.date}</th>
              <th id="heading-student" className="subtitle" scope="col">{translation.student}</th>
              <th id="heading-exam" className="subtitle" scope="col">{translation.exam}</th>
            </tr>
          </thead>
          <tbody>
            {events.map(
              (session, i) =>
              <tr key={i}>
                <td aria-labelledby="heading-date">
                  {moment(session.appointmentDate).local().tz(moment.tz.guess()).format('M/D/YYYY [at] h:mma z')}
                </td>
                <td aria-labelledby="heading-student">
                  {session.enrollment &&
                    `${session.enrollment.firstName} ${session.enrollment.lastName}`
                  }
                </td>
                <td aria-labelledby="heading-exam">
                  {session.exam &&
                    session.exam.title
                  }
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )
    } else {
      return (
        <span className="no-results">{translation.no_results}</span>
      )
    }
  }

  render() {
    const { translation } = this.props;

    return (
      <article className="panel--medium">
        <header className="panel__header">
          <h2 className="panel__title">{translation.heading}</h2>
        </header>

        <div className="panel__content">
          <div className="panel__copy">
            {this.renderResults()}

            <Link className="btn--outline" to="sessions">{translation.button}</Link>
          </div>
        </div>
      </article>
    )
  }
})

export default translate('UpcomingSessions')(UpcomingSessions);



// WEBPACK FOOTER //
// ./src/app/components/Dashboard/UpcomingSessions.js